import { CommonModule } from "@angular/common";
import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import {
  TicketBatch,
  TicketInBatch,
  TicketTransitionOption,
} from "../modal-tickets/types/ticket-batch.type";
import { BatchTransitionDialogFacade } from "../batch-transition-modal/batch-transition-dialog.facade";

@Component({
  selector: "app-batch-summary",
  providers: [BatchTransitionDialogFacade],
  imports: [CommonModule],
  templateUrl: "./batch-summary.component.html",
  styleUrl: "./batch-summary.component.scss",
})
export class BatchSummaryComponent {
  @Input() batch: TicketBatch | null = null;
  @Input() batchIndex = 0;
  @Input() management = false;
  @Input() transitionDisabledReason = "";
  @Output() batchesChanged = new EventEmitter<TicketBatch[]>();
  private readonly transitionDialog = inject(BatchTransitionDialogFacade);

  get transitionPending(): boolean {
    return this.transitionDialog.pending;
  }

  requestTransition(): void {
    if (
      !this.management ||
      !this.batch?.id ||
      !this.batch.can_transition ||
      this.batch.next_batch_number == null ||
      this.transitionDisabledReason ||
      this.transitionPending
    )
      return;
    this.transitionDialog
      .open({
        batchId: this.batch.id,
        nextBatchNumber: this.batch.next_batch_number,
      })
      .subscribe((batches: TicketBatch[] | undefined) => {
        if (Array.isArray(batches)) this.batchesChanged.emit(batches);
      });
  }

  ticketTransition(ticket: TicketInBatch): TicketTransitionOption | undefined {
    if (!this.batch || !ticket.id || !Array.isArray(this.batch.ticket_transitions)) {
      return undefined;
    }
    return this.batch.ticket_transitions.find((item) => item.ticket_id === ticket.id);
  }

  canTransitionTicket(ticket: TicketInBatch): boolean {
    if (
      !this.management ||
      !this.batch?.id ||
      !!ticket.transition_closed_at ||
      !!this.transitionDisabledReason ||
      this.transitionPending
    ) {
      return false;
    }
    const option = this.ticketTransition(ticket);
    return !!option?.can_transition && option.next_batch_number != null;
  }

  requestTicketTransition(ticket: TicketInBatch): void {
    const option = this.ticketTransition(ticket);
    if (!this.batch?.id || !ticket.id || !option || !this.canTransitionTicket(ticket)) {
      return;
    }
    this.transitionDialog
      .open({
        batchId: this.batch.id,
        nextBatchNumber: option.next_batch_number!,
        ticketIds: [ticket.id],
        ticketTitle: ticket.title,
      })
      .subscribe((batches: TicketBatch[] | undefined) => {
        if (Array.isArray(batches)) this.batchesChanged.emit(batches);
      });
  }

  getFinalPrice(price: number): number {
    const ticketPrice = Number(price);
    return this.batch?.pdv_only || this.batch?.absorbs_platform_fee
      ? ticketPrice
      : ticketPrice + ticketPrice * 0.1;
  }
}
